import { Badge, BadgeProps } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { MLModelType } from '@/types/model'

const MODEL_TYPE_NAMES = {
  [MLModelType.Primary]: 'models.type.stage1',
  [MLModelType.Secondary]: 'models.type.stage2'
}

type ModelTypeChipProps = {
  modelType: MLModelType
  size?: BadgeProps['size']
}

export const ModelTypeChip = ({
  modelType,
  size = 'xs'
}: ModelTypeChipProps) => {
  const name = MODEL_TYPE_NAMES[modelType]

  if (!name) {
    return null
  }

  return (
    <Badge color="brand-secondary" size={size}>
      <FormattedMessage id={name} />
    </Badge>
  )
}
